import { ReactComponent as BinIcon } from "assets/images/icons/icn_table_cell_Bin.svg";
import { ReactComponent as BinHoverIcon } from "assets/images/icons/icn_table_cell_Bin_hover.svg";

import React from "react";
import { useTheme } from "@mui/material/styles";
import { Button, Box } from "@mui/material";

const RemoveButton = ({ label, onHoverDeleteButton, isDeleteHovered, onOpenRemoveModal, showEditGeneral }) => {
  const theme = useTheme();

  return (
    <>
      <Box style={{ marginRight: 'auto' }}>
        <Button
          onMouseEnter={() => onHoverDeleteButton(true)}
          onMouseLeave={() => onHoverDeleteButton(false)}
          onClick={onOpenRemoveModal}
          startIcon={isDeleteHovered ? <BinHoverIcon /> : <BinIcon />}
          sx={{
            color: theme.palette.primary.main,
            fontSize: theme.typography.customFontSize[3],
            fontFamily: theme.typography.fontFamily,
            backgroundColor: theme.palette.primary.transparent,
            "&:hover": {
              backgroundColor: theme.palette.primary.transparent,
              color: theme.palette.primary.mainHover,
            },
            "&:active": {
              backgroundColor: theme.palette.primary.transparent,
              color: theme.palette.primary.main,
            },
            "&:disabled": {
              color: theme.palette.action.disabled,
            },
          }}
          disabled={!showEditGeneral}
        >
          {label}
        </Button>
      </Box>
    </>
  );
}

export default RemoveButton;